import L from 'leaflet';
import { useState } from 'react';
import { Marker, Popup, useMap } from 'react-leaflet';
import CourtPopup from './CourtPopup';
import { BASE_URL } from '../context/Navigation';

function CourtMarker({ id, lat, lng, name, active}) {
    const customIcon = new L.Icon({
        iconUrl:  active? `${BASE_URL}/activePin.png`:`${BASE_URL}/pins.png`, // URL of your icon image
        iconSize: [28, 35], // size of the icon
        iconAnchor: [14, 35], // point of the icon which will correspond to marker's location
        popupAnchor: [-3, -76], // point from which the popup should open relative to the iconAnchor
        //shadowUrl: null, // Disable the shadow by setting it to null
    });
    const map = useMap();
    

    return (lat && lng) ? <Marker title={name} autoPanOnFocus opacity={0.8} position={[lat, lng]} icon={customIcon} >
        <Popup offset={L.point(3, 47)} autoPan={false} closeOnClick={false} interactive={true}>
            <CourtPopup id={id} inName={name} lat={lat} lng={lng} ></CourtPopup>
        </Popup>
    </Marker> : <></>;
};

export default CourtMarker